import { render, staticRenderFns } from "./VisorPdf.vue?vue&type=template&id=1f67c21c&scoped=true"
import script from "./VisorPdf.vue?vue&type=script&lang=js"
export * from "./VisorPdf.vue?vue&type=script&lang=js"
import style0 from "./VisorPdf.vue?vue&type=style&index=0&id=1f67c21c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f67c21c",
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QCard,QCardSection,QIcon});
